import { api as dataEnteringApi } from "../api";
import { SalesInvoiceDraft } from "./types";
import { AppDispatch } from "../../../shared/redux/types";

interface FetchSalesInvoiceDraftParams {
    dispatch: AppDispatch;
    accountId: number | null;
    documentId: number | null;
}

export const salesInvoiceDraftApi = dataEnteringApi.injectEndpoints({
    endpoints: (build) => ({
        getSalesInvoiceDraft: build.query<SalesInvoiceDraft, { cacheKey: string }>({
            query: () => ({
                url: `api/v1/data_entering/sales_invoice_draft`,
            }),
            serializeQueryArgs: ({ queryArgs, endpointName }) =>
                `${endpointName}-${queryArgs.cacheKey}`,
        }),
    }),
});

export async function fetchSalesInvoiceDraft({
    dispatch,
    accountId,
    documentId,
}: FetchSalesInvoiceDraftParams): Promise<SalesInvoiceDraft> {
    const cacheKey = `${accountId}-${documentId}`;
    const draftPromise = dispatch(
        salesInvoiceDraftApi.endpoints.getSalesInvoiceDraft.initiate({ cacheKey }),
    );
    try {
        return await draftPromise.unwrap();
    } finally {
        draftPromise.unsubscribe();
    }
}
